namespace GeniuzPOS.ReportMasterData {
    export namespace Report1332ShopPaymentTypeRefTypeService {
        export const baseUrl = 'ReportMasterData/Report1332ShopPaymentTypeRefType';

        export declare function Create(request: Serenity.SaveRequest<Report1332ShopPaymentTypeRefTypeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<Report1332ShopPaymentTypeRefTypeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Report1332ShopPaymentTypeRefTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<Report1332ShopPaymentTypeRefTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ReportMasterData/Report1332ShopPaymentTypeRefType/Create",
            Update = "ReportMasterData/Report1332ShopPaymentTypeRefType/Update",
            Delete = "ReportMasterData/Report1332ShopPaymentTypeRefType/Delete",
            Retrieve = "ReportMasterData/Report1332ShopPaymentTypeRefType/Retrieve",
            List = "ReportMasterData/Report1332ShopPaymentTypeRefType/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>Report1332ShopPaymentTypeRefTypeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
